import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import API_CONFIG from '../../config/config'
import { PLANS_MAPPING } from "../../component/layout/plan/constants";
import { KIOSK_INCLUDED_CONFIG, ADD_ON_CONFIG, ADD_ON_KEY } from "./constants/plans";
import { isKioskIncludedOption, isObligatoryOption, isOptionDeprecated } from "./helper/plans";

const { apiURL } = API_CONFIG;

// TODO: Refactor this update the name of the reducer to be more descriptive -- Old code made by mansicarpermint, we are refactoring when we have time.
// Move the logic to the store for fixing the issue of hardcoded ids in SelectKioskTypePopUp. This is a quick fix that we will refactor later.

export const fetchPlans = createAsyncThunk(
  'plans/fetchPlans',
  async (_, { getState }) => {
    const state = getState();
    
    if (state.plans.data) {
      return {
        data: state.plans.data,
        includedKioskByPlanId: state.plans.includedKioskByPlanId,
        addOnsByPlanId: state.plans.addOnsByPlanId
      }
    };

    const plansRequest = await axios.get(apiURL + '/signup/plans/');
    const plansData = plansRequest.data;
    
    // Plans data for state
    const data = [];
    // Included kiosk by type for state
    const includedKioskByPlanId = {};
    // Add ons by plan id for state
    const addOnsByPlanId = {};

    for (const plan of plansData) {
      plan.displayName = PLANS_MAPPING[plan.name]?.displayName || plan.name;
      data.push(plan);
      const options = plan?.options || [];

      const includedKioskTypes = [];
      const plansAddOns = {};
      const addOnsKeys = Object.values(ADD_ON_KEY);
      options.forEach(option => {
        if(isOptionDeprecated(option)) return;
        const isKioskIncluded = isKioskIncludedOption(option);
        if(isKioskIncluded) {
          return includedKioskTypes.push({
            ...KIOSK_INCLUDED_CONFIG[option.key_name],
            id: option.id,
          });
        }
        if(isObligatoryOption(option)) return;
        const addOnKey = addOnsKeys.find(key => option.key_name.startsWith(key));
        if(!addOnKey) return;
        const isMonthly = option.key_name.includes('monthly');
        const isUpfront = option.key_name.includes('upfront');

        const key = (isMonthly && 'monthly') || (isUpfront && 'upfront');

        if(!key) return;

        const data = {
          [key]: {
            id: option.id,
            price_type: key,
            ...ADD_ON_CONFIG[addOnKey],
            ...option,
            priceCents: option.prices.find(price => price.price_type === key)?.cents,
          }
        }

        if(!plansAddOns[addOnKey]) {
          plansAddOns[addOnKey] = data;
        } else {
          plansAddOns[addOnKey] = {
            ...plansAddOns[addOnKey],
            ...data
          }
        }
      });
      includedKioskByPlanId[plan.id] = includedKioskTypes;
      addOnsByPlanId[plan.id] = plansAddOns;
    }
    return { data, includedKioskByPlanId, addOnsByPlanId };
  }
);
const plans = createSlice({
    name: 'plans',
    initialState: { },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(fetchPlans.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchPlans.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload.data;
          state.includedKioskByPlanId = action.payload.includedKioskByPlanId;
          state.addOnsByPlanId = action.payload.addOnsByPlanId;
        })
        .addCase(fetchPlans.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
    }
})

export default plans.reducer;